class ContactQuery {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    this.email = data ? data.email : ''
    this.comment = data ? data.comment : ''
    this.created_at = data ? data.created_at : ''
  }
}

export default ContactQuery



// WEBPACK FOOTER //
// ./src/models/ContactQuery.js